var _circle, _circle2, _circle3, _circle4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _path2, _rect10, _path3, _rect11, _path4, _rect12, _path5, _path6, _rect13, _path7, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 347,
    viewBox: "0 0 337 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 287,
    r: 25,
    fill: "#E79782",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 287,
    r: 20,
    fill: "#E79782",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 287,
    r: 15,
    fill: "#E79782",
    fillOpacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 287,
    r: 10,
    fill: "#E79782"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 252,
    y: 102.698,
    width: 42,
    height: 42,
    rx: 5,
    transform: "rotate(-45 252 102.698)",
    fill: "#55E4DF",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 264.307,
    y: 102.305,
    width: 25,
    height: 25,
    rx: 5,
    transform: "rotate(-45 264.307 102.305)",
    fill: "#55E4DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 257.347,
    y: 101.857,
    width: 34.5147,
    height: 34.7818,
    rx: 5,
    transform: "rotate(-45 257.347 101.857)",
    fill: "#55E4DF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 34,
    width: 218,
    height: 296,
    rx: 20,
    fill: "#2D2C3C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 202,
    width: 161,
    height: 14,
    rx: 7,
    fill: "#48485D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 149,
    width: 161,
    height: 14,
    rx: 7,
    fill: "#48485D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 96,
    width: 161,
    height: 14,
    rx: 7,
    fill: "#48485D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 255,
    width: 161,
    height: 14,
    rx: 7,
    fill: "#48485D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.579 34.5C113.579 41.8983 108.983 47 104.289 47C99.596 47 95 41.8983 95 34.5C95 27.1017 99.596 22 104.289 22C108.983 22 113.579 27.1017 113.579 34.5Z",
    stroke: "#53536C",
    strokeWidth: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 33.1199,
    height: 27.4834,
    transform: "matrix(0.999906 0.0137112 -0.0174741 0.999847 104.77 34)",
    fill: "#2D2C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.617 34.5C151.617 41.8983 147.021 47 142.327 47C137.634 47 133.038 41.8983 133.038 34.5C133.038 27.1017 137.634 22 142.327 22C147.021 22 151.617 27.1017 151.617 34.5Z",
    stroke: "#53536C",
    strokeWidth: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 33.1199,
    height: 27.4834,
    transform: "matrix(0.999906 0.0137112 -0.0174741 0.999847 142.808 34)",
    fill: "#2D2C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.655 34.5C189.655 41.8983 185.059 47 180.365 47C175.672 47 171.076 41.8983 171.076 34.5C171.076 27.1017 175.672 22 180.365 22C185.059 22 189.655 27.1017 189.655 34.5Z",
    stroke: "#53536C",
    strokeWidth: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 33.1199,
    height: 27.4834,
    transform: "matrix(0.999906 0.0137112 -0.0174741 0.999847 180.845 34)",
    fill: "#2D2C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.692 34.5C227.692 41.8983 223.096 47 218.403 47C213.71 47 209.114 41.8983 209.114 34.5C209.114 27.1017 213.71 22 218.403 22C223.096 22 227.692 27.1017 227.692 34.5Z",
    stroke: "#53536C",
    strokeWidth: 4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 33.1199,
    height: 27.4834,
    transform: "matrix(0.999906 0.0137112 -0.0174741 0.999847 218.883 34)",
    fill: "#2D2C3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241 299C241 292.373 246.373 287 253 287H289C295.627 287 301 292.373 301 299V335C301 341.627 295.627 347 289 347H253C246.373 347 241 341.627 241 335V299Z",
    fill: "#B18DF8",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.286 303.286C245.286 296.658 250.658 291.286 257.286 291.286H284.714C291.342 291.286 296.714 296.658 296.714 303.286V330.714C296.714 337.342 291.342 342.714 284.714 342.714H257.286C250.658 342.714 245.286 337.342 245.286 330.714V303.286Z",
    fill: "#B18DF8",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 297,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#B18DF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.55 307C278.041 307.001 277.538 307.103 277.069 307.3C276.6 307.497 276.175 307.784 275.818 308.146L260.952 323.011L260.893 323.306L259.865 328.476L259.571 329.856L260.952 329.563L266.123 328.535L266.416 328.475L281.283 313.61C281.646 313.253 281.934 312.828 282.131 312.359C282.327 311.89 282.429 311.386 282.429 310.878C282.429 310.369 282.327 309.865 282.131 309.396C281.934 308.927 281.646 308.502 281.283 308.145C280.925 307.783 280.5 307.496 280.031 307.299C279.562 307.103 279.058 307.001 278.55 307V307ZM278.55 308.792C279.024 308.792 279.501 309.008 279.96 309.468C280.875 310.382 280.875 311.373 279.96 312.288L279.285 312.934L276.493 310.143L277.14 309.468C277.599 309.008 278.076 308.792 278.55 308.792V308.792ZM275.172 311.466L277.962 314.257L266.593 325.625C265.979 324.424 265.002 323.448 263.801 322.835L275.172 311.466ZM262.598 324.363C263.154 324.587 263.66 324.921 264.084 325.345C264.508 325.769 264.842 326.275 265.066 326.831L261.98 327.448L262.598 324.363Z",
    fill: "#F8F8F8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_15_800)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 85,
    r: 2,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 85,
    r: 4,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 85,
    r: 5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 34,
    r: 2,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 34,
    r: 4,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 34,
    r: 5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 313,
    r: 2,
    fill: "#D9D9D9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 313,
    r: 4,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 313,
    r: 5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 233,
    r: 2,
    transform: "rotate(-3.71603 35 233)",
    fill: "#D9D9D9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 233,
    r: 4,
    transform: "rotate(-3.71603 35 233)",
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 233,
    r: 5,
    transform: "rotate(-3.71603 35 233)",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_800",
    x1: 9.5,
    y1: 3,
    x2: 22,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E3E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0992633,
    stopColor: "#4E362E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteBook);
export default __webpack_public_path__ + "static/media/noteBook.c19f5707c9ee4e3658bbc2528061de2f.svg";
export { ForwardRef as ReactComponent };